import React, { useState } from "react";
import "./Agents.css";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { submitDeliveryExcellenceRequest } from "../../../../store/features/actions/deliveryExcellenceActions";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import * as FeatherIcon from "react-feather";

export default function DeliveryExcellence({
  contentRef = null,
  copied = false,
  handleCopy = () => {},
  exportTablesToCSV = () => {}
}) {
  const {clientName, accountName} = useParams();
  const dispatch = useDispatch();
  const { loading, successMessage, errorMessage } = useSelector(state => state.deliveryExcellenceReducer);

  const [contact, setContact] = useState("");
  const [context, setContext] = useState("");
  const [contextFile, setContextFile] = useState(null);
  const [contextFileError, setContextFileError] = useState("");
  const [outputFile, setOutputFile] = useState(null);
  const [outputFileError, setOutputFileError] = useState("");
  const [errors, setErrors] = useState({});
  const [showMoreModal, setShowMoreModal] = useState(false);

  const allowedTypes = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  ];
  
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name; // e.g., 'contextFile' or 'outputFile'
  
    if (!file || !allowedTypes.includes(file.type)) {
      if (fieldName === "contextFile") {
        setContextFileError("Only PDF or DOCX files are allowed.");
        setContextFile(null);
      } else if (fieldName === "outputFile") {
        setOutputFileError("Only PDF or DOCX files are allowed.");
        setOutputFile(null);
      }
    } else {
      if (fieldName === "contextFile") {
        setContextFileError("");
        setContextFile(file);
      } else if (fieldName === "outputFile") {
        setOutputFileError("");
        setOutputFile(file);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = {};

    // if (!contact) validationErrors.contact = "Contact is required.";
    if (!context) validationErrors.context = "Context is required.";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const formData = {
      clientName: clientName,
      accountName: accountName,
      context: context,
      contextFile: contextFile,
      outputFile: outputFile,
      contact
    };

    setErrors({});
    dispatch(submitDeliveryExcellenceRequest({ formData }));

    setTimeout(function(){
      setShowMoreModal(true);
    }, successMessage);
  };

  let names = [];
  if(accountName === "MOOG INC"){
    names = [
      "Patrick J Roche",
      "Jennifer Walter",
      "Paul Wilkinson",
      "Joe Alfieri",
      "Stu McLachlan",
      "Mark Graczyk",
      "Michael Schaff",
    ];
  } else if (accountName === "PANASONIC CORPORATION"){
    names = [
      "Yuki Kusumi",
      "Tetsuro Homma",
      "Hajime Tamaoki",
      "Tatsuo Kinoshita",
      "Megan Myungwon Lee",
      "Tatsuo Ogawa",
      "Ayako Shotoku",
      "Shigeo Usui",
      "Akira Waniko",
    ];
  } else if (accountName === "VALVOLINE INC"){
    names = [
      "Valvoline contacts",
      "Lori flees",
      "Mary Meixelsperger",
      "Linne Fulcher",
      "Adam Worsham",
      "Brian Tabb",
      "Travis Dobbins",
      "Chris Calabrese",
      "Joe Certo",
      "Keith Peshke"
    ];
  } else {
    names = [];
  }

  return (
    <div className="custom_card_block mb-2 mt-4">
      <div className="closure_note_wrapper">
        <div className="head_top">
          <h5 className="main_head">Delivery Excellence Note</h5>
        </div>
        <div className="closure_block mt-3">
          <Form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3 custom_agentform_group">
                  {/* <Form.Label className="custom_agentform_label">Select Contact <span className="red">*</span></Form.Label> */}
                  <Form.Label className="custom_agentform_label">Select Contact</Form.Label>
                  <Form.Select
                    className="custom_agentform_control"
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                  >
                    <option value="">Select Contact</option>
                    {names.map((name, index) => (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.contact && <p className="text-danger">{errors.contact}</p>}
                </Form.Group>
              </div>
            </div>

            <div className="col-md-12">
              <Form.Group className="mb-3 custom_agentform_group">
                <Form.Label className="custom_agentform_label">Provide additional context <span className="red">*</span></Form.Label>
                <Form.Control
                  as="textarea"
                  className="contextArea"
                  placeholder="Include deal specifics and any additional context here"
                  rows={3}
                  value={context}
                  onChange={(e) => setContext(e.target.value)}
                />
                {errors.context && <p className="text-danger">{errors.context}</p>}
              </Form.Group>
            </div>

            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3 custom_agentform_group">
                  <Form.Label className="custom_agentform_label d-block">Context File</Form.Label>
                  <input name="contextFile" type="file" accept=".pdf,.docx" className="custom_agentform_file" onChange={handleFileChange} />
                  {contextFileError && <p className="text-danger">{contextFileError}</p>}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3 custom_agentform_group">
                  <Form.Label className="custom_agentform_label d-block">Output File</Form.Label>
                  <input name="outputFile" type="file" accept=".pdf,.docx" className="custom_agentform_file" onChange={handleFileChange} />
                  {outputFileError && <p className="text-danger">{outputFileError}</p>}
                </Form.Group>
              </div>
            </div>

            <div className="col-md-12">
              <div className="prev_next_block">
                <button type="submit" className="genrate_modal_btn  btn btn-primary" disabled={loading}>
                  {loading ? "Submitting..." : "Generate"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary cancel_modal_btn"
                  onClick={() => {
                    setContact("");
                    setContext("");
                    setContextFile(null);
                    setContextFileError("");
                    setOutputFile(null);
                    setOutputFileError("");
                    setErrors({});
                  }}
                >
                  Clear
                </button>
              </div>
            </div>
            {/* {successMessage && <p className="text-success">{successMessage}</p>} */}
            {errorMessage && <p className="text-danger">{errorMessage}</p>}
          </Form>
        </div>
      </div>

      {showMoreModal && successMessage && (
        // <>
        <GenericOverviewSideCard
          showMoreModal={showMoreModal}
          titleForSideCard={
            <div
              className="promters_head"
              style={{
                display:"flex",
                justifyContent:"space-between"
              }}
            >
                            <div className="clousre_head">

              <h5 style={{marginRight: "5px"}}>
                Delivery Excellence Note
              </h5>
              </div>
              <div className="copy_clousre">

              <span>
                <FeatherIcon.Copy
                  className="copy_note fa"
                  onClick={handleCopy}
                />
                <span
                  className={`copy-message ${
                    copied ? "copy-fade-in" : "copy-fade-out"
                  }`}
                >
                  Note Copied !
                </span>
                {/* <img
                  src="/img/icons/copy.png"
                  onClick={exportTablesToCSV}
                  alt="csv"
                  width="20"
                  class=""
                >
                </img> */}
              </span>
            </div>
            </div>

          }
          setShowMoreModal={setShowMoreModal}
          comp={
          <div ref={contentRef}>

            <div className="row">
              <div className="col-md-3">
                <p className="overview_head_agents">Persona Name:</p>
              </div>
              <div className="col-md-9 subhead_content">
                {contact}
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <p className="overview_head_agents">Context:</p>
              </div>
              <div className="col-md-9 subhead_content">
                {context}
              </div>
            </div>
            <div className="closure_result mt-4" dangerouslySetInnerHTML={{ __html: successMessage }} />
          </div>
        }/>
        // </>
      )}

    </div>
  );
}
